function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* istanbul ignore file */

import { useEffect, useRef, useState } from 'react';
import { useMutationObserver } from "../useMutationObserver";
import { getHeight } from "./utils";
var IS_EXPANDED_INITIAL = true;
var HEIGHT_INITIAL = 'auto';
export var useExpandableContent = function useExpandableContent(_ref) {
  var elementWrapper = _ref.elementWrapper,
    isExpandable = _ref.isExpandable,
    minHeight = _ref.minHeight,
    _ref$observeSubtree = _ref.observeSubtree,
    observeSubtree = _ref$observeSubtree === void 0 ? false : _ref$observeSubtree;
  var _useState = useState(IS_EXPANDED_INITIAL),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = useState(HEIGHT_INITIAL),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var maxHeight = useRef(0);
  var mutationList = useMutationObserver(elementWrapper.current, {
    childList: true,
    subtree: observeSubtree
  });
  var toggleExpanded = function toggleExpanded() {
    setExpanded(!isExpanded);
    setHeight(isExpanded ? minHeight : maxHeight.current);
  };
  var getMaxHeight = function getMaxHeight() {
    return elementWrapper.current ? getHeight(elementWrapper.current, elementWrapper.current.childNodes[elementWrapper.current.childNodes.length - 1]) : 0;
  };
  useEffect(function () {
    setExpanded(false);
    if (isExpandable) {
      setHeight(minHeight);
    } else {
      setHeight('auto');
    }
  }, [isExpandable, minHeight]);
  useEffect(function () {
    maxHeight.current = getMaxHeight();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementWrapper]);
  useEffect(function () {
    var calculateNewHeight = function calculateNewHeight() {
      maxHeight.current = getMaxHeight();
      if (isExpanded) {
        setHeight(maxHeight.current);
      }
    };
    if (mutationList.length) {
      calculateNewHeight();
    }
    window.addEventListener('resize', calculateNewHeight);
    return function () {
      return window.removeEventListener('resize', calculateNewHeight);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mutationList, isExpanded]);
  return {
    height,
    isExpanded,
    toggleExpanded
  };
};